// 新建任务页面
import React from "react";
import { Upload, message, Form, Input, Button } from "antd";
import { prefixFile } from "@/fetch/fetchApi";
// 国际化切换语言
import { injectIntl } from "react-intl";
// 样式
import "./index.styl";

class TaskBuildStep1 extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.cfgChangeTaskBuild;
    this.state = {
      fileName: "",
      buttonDescrible: this.props.intl.messages.cfgChangeTaskBuild.btn1, // "配置上传",
    };
  }

  // 设置Form的ref
  formRef = React.createRef();

  render() {
    const uploadProps = {
      name: "file",
      multiple: false,
      accept: ".xls",
      action:
        `${prefixFile}/oss/importStubCfg.do?taskName=${
          this.props.taskName
        }&taskId=${this.props.taskId} `,
      headers: {
        authorization: "authorization-text",
      },
      showUploadList: false,
      // progress:{
      //     type:'line'
      // },
      onChange: (info) => {
        console.log(info);
        this.setState({
          btnLoading: true,
        });
        if (info.file.response !== undefined && info.file.response === 1) {
          this.setState({
            btnLoading: false,
          });
          this.state.display = "";
          message.success(info.file.name + this.internationalization.msg3);
          this.state.fileName = info.file.name;
          this.state.buttonDescrible = this.internationalization.msg4;
          this.props.changeStep(2, true);
          this.props.setFileName(info.file.name);
        } else if (info.file.response !== undefined && info.file.response.status !== "200") {
          this.setState({
            btnLoading: false,
          });
          message.error(`${info.file.name}上传失败`);
        }
      },
    };
    const content = (
      <div className="step1-content">
        <Form ref={this.formRef}>
          <Form.Item
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}
            label="任务名称"
            name="taskName"
            initialValue={this.props.taskName}>
            <Input disabled />
          </Form.Item>
          <div style={{ paddingBottom: 30 }}>
            <Upload {...uploadProps}>
              <Button
                type="primary"
                loading={this.state.btnLoading}
                disabled={this.state.btnLoading}
                style={{ display: this.state.btnDisplay, margin: "0 auto" }}>
                上传并校验
                {/* <UploadOutlined />{this.state.buttonDescrible} */}
              </Button>
            </Upload>
          </div>
          <div className="tip-info">
            <div className="tip-left">注：</div>
            <div className="tip-info-wz">
              1. 上传配置前需要先线下修改好excel配置文件 <br />
              2. 配置文件设备数量最好不要大于200个，超过时建议减少桩数量，分批修改
            </div>
          </div>
        </Form>
      </div>
    );
    return content;
  }
}

export default injectIntl(TaskBuildStep1);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/taskBuildStep1.js